import { devWarning } from '../dev-log';
/** 返回 `Not in app` 消息的错误对象 */
export function notInApp(_a) {
  var api = _a.api,
    param = _a.param;
  devWarning(api, param);
  return new Error(notInApp.ERROR_MESSAGE);
}
notInApp.ERROR_MESSAGE = 'Not in app';